import { Box, Flex } from '@chakra-ui/react';
import { useContractQuery } from 'generated/graphql';
import { Outlet } from 'react-router-dom';
import { useToken } from '../lib';
import DocumentList from './DocumentList';

function Contract() {
  const token = useToken();

  const { loading, data } = useContractQuery({ variables: { token } });

  if (loading || !data) return null;

  const documents = data.contract.documents.edges.map(edge => edge.node!);

  return (
    <Flex height="100%" p="20px" borderTop="8px" borderColor="purple.500">
      <DocumentList documents={documents} />
      <Box flex={1} p={2} w="100%">
        <Outlet />
      </Box>
    </Flex>
  );
}

export default Contract;
